const { showError, showNotifikasi } = require('../../libs/helper');
var qs = require('qs');

module.exports = {
    getIndexDetail: (g, params) => {
        let result = g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/pendalaman/detail/register-b',
            method: 'post',
            data: qs.stringify(params),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            console.log(err)
        })
        return result;
    },

    getDataPendalamanRegister: (g, params) => {
        const result = g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/pendalaman/list',
            method: 'post',
            data: qs.stringify(params),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        }).then(res => res.data).catch(err => {

            showError(g, err, 'Error Get Data')
        })
        return result
    },
    getDetailPendalamanRegister: (g, params) => {
        const result = g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/pendalaman/detail/hasil-sensus',
            method: 'post',
            data: qs.stringify(params),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        }).then(res => res.data).catch(err => {
            showError(g, err, 'Error Get Data')
            return err;
        })
        return result;

    },
    submitPengajuan: (g, data) => {
        const formData = new FormData();
        let file = data.fisik_tidak_ditemukan.file_dokumen_sk;
        delete data.fisik_tidak_ditemukan.file_dokumen_sk;
        formData.append('json', JSON.stringify(data));
        formData.append('file', file);

        // for (const key in data) {
        //     if (data[key] instanceof Object && !(data[key] instanceof File)) {
        //         for (const subKey in data[key]) {
        //             formData.append(`${key}.${subKey}`, data[key][subKey]);
        //         }
        //     } else {
        //         formData.append(key, data[key]);
        //     }
        // }
        let result = g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/pendalaman/submit',
            method: 'post',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            return res.data;
        }).catch(err => {
            return err;
        })
        return result;
    }

}